import React from "react";
export var NotificationCriticalIcon = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M512 128c212 0 384 172 384 384S724 896 512 896 128 724 128 512s172-384 384-384zm-32 150c-8 8-11 20-11 31l11 249c0 9 3 18 10 24 6 5 14 8 22 8 9 0 17-3 23-8 6-6 10-15 9-24l13-249c0-12-5-23-13-31-9-9-20-13-32-13s-24 4-32 13zm67 469v-1c10-9 16-22 15-36 0-13-5-26-15-35-9-9-22-15-35-14-14-1-26 5-36 14-9 9-15 22-14 35-1 14 5 28 15 37 20 18 50 18 70 0z"
}));